// extracted by mini-css-extract-plugin
export default {"customPopOverContainer":"CustomPopOver_customPopOverContainer__FlkBp","customProfileInfoContainer":"CustomPopOver_customProfileInfoContainer__X7n4+"};